import { axiosInstance } from "@/api/axios";
import { AxiosRequestConfig } from "axios";
import { ExpenseDraftFormValue } from "../types/expenseDraft";

// Expense Draft API functions
export const getExpenseDrafts = async (config?: AxiosRequestConfig) => {
  const params = config?.params;

  if (params?.sort) {
    params.sort = JSON.stringify(params.sort);
  }

  if (params?.filters) {
    params.filters = JSON.stringify(params.filters);
  }

  const response = await axiosInstance.get("/expense-drafts", { params });
  return response.data;
};

export const createExpenseDraft = async (payload: ExpenseDraftFormValue) => {
  const response = await axiosInstance.post("/expense-drafts", payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const updateExpenseDraft = async (
  id: string,
  payload: ExpenseDraftFormValue
) => {
  const response = await axiosInstance.put(`/expense-drafts/${id}`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const deleteExpenseDraft = async (id: string) => {
  const response = await axiosInstance.delete(`/expense-drafts/${id}`);
  return response.data;
};

export const deleteExpenseDraftBulk = async (ids: string[]) => {
  const response = await axiosInstance.delete(`/expense-drafts/bulk`, {
    data: {
      draft_ids: ids,
    },
  });
  return response.data;
};
